import { ThemeProvider } from 'react-jss'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { ConfigProvider } from 'antd'

import App from './App'
import theme, { antTheme } from './theme/bioBridge'
import globalStyle from './theme/globalStyle'
import store from './redux/store'
import Auth0ProviderWithHistory from './components/Auth/Auth0ProviderWithHistory'

function Root() {
  return (
    <Provider store={store}>
      <Router>
        <ThemeProvider theme={theme}>
          <ConfigProvider theme={antTheme}>
            <Auth0ProviderWithHistory>
              <App />
              <style>{globalStyle()}</style>
            </Auth0ProviderWithHistory>
          </ConfigProvider>
        </ThemeProvider>
      </Router>
    </Provider>
  )
}

export default Root
